import { TEnumerationType } from "./type";

export type TDownloadBaiscInfomation = 'hasCompany' | 'hasGenre' | 'hasRelease' | 'hasRegion' | 'hasSteamId' | 'hasSteamTags'| 'hasGameMode' | 'hasGameEngine' | 'hasMetaCriticScore' | 'hasGamesOwned' | 'hasIPOStatus' | 'hasHeadquaters' | 'hasLanguage' | 'hasUrl' | 'hasGameType';
export type TBasicInfoResult = 'company_show' | 'genre_show' | 'release_date_show' | 'region_show' | 'steam_id_show' | 'steam_tag_show' | 'game_mode_show' | 'game_engine_show' | 'meta_score_show' | 'games_owned_show' | 'ipo_status_show' | 'headquaters_show' | 'lang_region_show' | 'url_show' | 'game_type_show';

export type TDownloadDataCalculationOptionsKey = 'isEditionAggregated' | 'isByEdition' | 'isByTime' | 'isSeparateByTime' | 'isTimeAggregated' | 'isCountryAggregated' | 'isSeperateByCountries' | 'isSeperateByRegion' | 'isPlatformAggregated' | 'isByPlatform' | 'isSegmentAggregated' | 'isBySegment' | 'isByGenre' | 'isBySubGenre' | 'isGamesAggregated' | 'isByGames' | 'isAnchorsAggregated' | 'isShowTopInfluencers' | 'isByCountries' | 'isByRegion' | 'isRegion' | 'isCoreMarkets' | 'isGenreAggregated';
export type TDownloadDataCalculationOptionsValue = 'aggregated' | 'edition' | 'market' | 'region' | 'separate' | 'parentGenre' | 'subGenre' | 'date';
export type TDownloadOtherOptionsKey = 'exportAllData' | 'selectTop' | 'exportExcel' | 'exportCSV' | 'exportSelected' | 'exportSpecialSelected';
export type TDownloadOtherOptionsValue = 'all' | 'top' | 'excel' | 'csv' | 'selected' | 'specialSelected';
export type TDownloadMainCategory = 'source' | 'dataSource' | 'streamSource' | 'timeScale' | 'benchmarkMetrics' | 'basicInformation' | 'dataCalculation' | 'benchmarkPlatformSettings' | 'regionSettings' | 'dataAmount' | 'selectTop' | 'fileFormat' | 'basicInformationOptional' | 'specialCountrySettring' | 'otherSettings' | 'ratio' | 'metrics' | 'dataSettings' | 'special_dateSettings' | 'specialDataSettings' | 'timeSettings' | 'editionSettings' | 'dateSettings' | 'timeSettingsDateType' | 'platformSettings' | 'special_platformSettings' | 'platformSettingsNPD' | 'platformSettingsGSD' | 'platformSettingsMscience' | 'platformSettingsFamitsu' | 'gamePlatform' | 'genreCategory' | 'dataCategory' | 'genre' | 'platform' | 'marketSettings' | 'genreSettings' | 'timeSettingsByTime' | 'special_dateSettingsByTime' | 'overlapMetrics' | 'overlapPlatformSettings' | 'timePickerSettings' | 'countrySettings' | 'dataCalculationChange' | 'special_datePickerSettings' | 'chart' | 'special_dataCalculationChange' | 'SpecialDataCategory' | 'anchorsSettings' | 'gameSettings' | 'mobileSource' | 'mobileMetrics' | 'specialEditionSettings' | 'mobileDateSettings' | 'mutilMetrics' | 'singleMetrics' | 'companiesMetrics';

export interface IDownloadBaiscInfomationProp {
  // 自身的key
  key: TDownloadBaiscInfomation | TDownloadDataCalculationOptionsKey | TDownloadOtherOptionsKey | TDownloadMainCategory;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: TBasicInfoResult | TDownloadDataCalculationOptionsValue | TDownloadOtherOptionsValue | TDownloadMainCategory;
  // 展示在什么平台
  platform?: string;
  enumType: TEnumerationType;
};

export type IDownloadBaiscInfomation = Record<TDownloadBaiscInfomation, IDownloadBaiscInfomationProp>
export type IDownloadDataCalculationOptions = Record<TDownloadDataCalculationOptionsKey, IDownloadBaiscInfomationProp>
export type IDownloadOtherOptions = Record<TDownloadOtherOptionsKey, IDownloadBaiscInfomationProp>
export type IDownloadMainCategory = Record<TDownloadMainCategory, IDownloadBaiscInfomationProp>

const DOWNLOAD_OPTIONS_COMMON = {
  aggregated: {
    label: 'Aggregated',
    labelKey: 'dbi_label_aggregated',
  },
  selected: {
    label: 'Export selected',
    labelKey: 'dbi_export_checked_lines',
  }
};

export const DOWNLOAD_BASIC_INFOMATION: IDownloadBaiscInfomation = {
  hasCompany: {
    label: 'Company information',
    labelKey: 'dbi_label_company_info',
    value: 'company_show',
    key: 'hasCompany',
    platform: 'benchmark,compare,console,consoleDetail,following,mobile,mobileDetail,overlap,pc,pc&console,pc&consoleDetail,pcDetail,storaRank,streaming',
    enumType: 'downloadBasicInfo',
  },
  hasGenre: {
    label: 'Genre',
    labelKey: 'dbi_label_genre',
    key: 'hasGenre',
    value: 'genre_show',
    platform: 'benchmark,compare,console,consoleDetail,following,mobile,mobileDetail,overlap,pc,pc&console,pc&consoleDetail,pcDetail,storaRank,streaming',
    enumType: 'downloadBasicInfo',
  },
  hasRelease: {
    label: 'Release Date',
    labelKey: 'dbi_label_release_date',
    key: 'hasRelease',
    value: 'release_date_show',
    platform: 'benchmark,compare,console,consoleDetail,following,mobile,mobileDetail,overlap,pc,pc&console,pc&consoleDetail,pcDetail,storaRank,streaming',
    enumType: 'downloadBasicInfo',
  },
  hasRegion: {
    label: 'Region',
    labelKey: 'dbi_area_region',
    key: 'hasRegion',
    value: 'region_show',
    platform: 'benchmark,compare,console,consoleDetail,following,overlap,pc,pc&consoleDetail,pcDetail',
    enumType: 'downloadBasicInfo',
  },
  hasSteamId: {
    label: 'Steam id',
    labelKey: 'dbi_steam_id',
    key: 'hasSteamId',
    value: 'steam_id_show',
    platform: 'compare,pc,pc&console,pc&consoleDetail,pcDetail',
    enumType: 'downloadBasicInfo',
  },
  hasSteamTags: {
    label: 'Steam Tags',
    labelKey: 'dbi_top_steam_tags',
    key: 'hasSteamTags',
    value: 'steam_tag_show',
    platform: 'pc&console,pc&consoleDetail',
    enumType: 'downloadBasicInfo',
  },
  hasGameMode: {
    label: 'Game Mode',
    labelKey: 'dbi_top_game_mode',
    key: 'hasGameMode',
    value: 'game_mode_show',
    platform: 'console',
    enumType: 'downloadBasicInfo',
  },
  hasGameEngine: {
    label: 'Game Engine',
    labelKey: 'dbi_top_game_engine',
    key: 'hasGameEngine',
    value: 'game_engine_show',
    platform: 'pc&console,mobile',
    enumType: 'downloadBasicInfo',
  },
  hasMetaCriticScore: {
    label: 'MetaCritic Score(Global)',
    labelKey: 'dbi_metric_metacritic_global',
    key: 'hasMetaCriticScore',
    value: 'meta_score_show',
    platform: 'pc&console',
    enumType: 'downloadBasicInfo',
  },
  hasGamesOwned: {
    label: 'Games Owned',
    labelKey: 'dbi_company_game_owned',
    key: 'hasGamesOwned',
    value: 'games_owned_show',
    platform: 'companies',
    enumType: 'downloadBasicInfo',
  },
  hasIPOStatus: {
    label: 'IPO Status',
    labelKey: 'dbi_company_ipo_status',
    key: 'hasIPOStatus',
    value: 'ipo_status_show',
    platform: 'companies',
    enumType: 'downloadBasicInfo',
  },
  hasHeadquaters: {
    label: 'Headquaters',
    labelKey: 'dbi_company_headquaters',
    key: 'hasHeadquaters',
    value: 'headquaters_show',
    platform: 'companies',
    enumType: 'downloadBasicInfo',
  },
  hasLanguage: {
    label: 'Language/Country',
    labelKey: 'dbi_streaming_language_country',
    key: 'hasLanguage',
    value: 'lang_region_show',
    platform: 'streaming',
    enumType: 'downloadBasicInfo',
  },
  hasUrl: {
    label: 'Channel URL',
    labelKey: 'dbi_streaming_channel_url',
    key: 'hasUrl',
    value: 'url_show',
    platform: 'streaming',
    enumType: 'downloadBasicInfo',
  },
  hasGameType: {
    label: 'Game Type',
    labelKey: 'dbi_selector_game_type',
    key: 'hasGameType',
    value: 'game_type_show',
    platform: 'streaming',
    enumType: 'downloadBasicInfo',
  },
};

export const DOWNLOAD_DATA_CALCULATION_OPTIONS: IDownloadDataCalculationOptions = {
  isEditionAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isEditionAggregated',
    enumType: 'downloadDataCalcu',
  },
  isByEdition: {
    label: 'By Edition',
    labelKey: 'dbi_label_separate_by_edition',
    value: 'edition',
    key: 'isByEdition',
    enumType: 'downloadDataCalcu',
  },
  isByTime: {
    label: 'By Time',
    labelKey: 'dbi_label_separate_by_time_combine',
    value: 'separate',
    key: 'isByTime',
    enumType: 'downloadDataCalcu',
  },
  isSeparateByTime: {
    label: 'Separate by Time',
    labelKey: 'dbi_label_separate_by_time',
    value: 'separate',
    key: 'isSeparateByTime',
    enumType: 'downloadDataCalcu',
  },
  isTimeAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isTimeAggregated',
    enumType: 'downloadDataCalcu',
  },
  isCountryAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isCountryAggregated',
    enumType: 'downloadDataCalcu',
  },
  isSeperateByCountries: {
    label: 'Separate by Country',
    labelKey: 'dbi_label_separate_by_country',
    value: 'market',
    key: 'isSeperateByCountries',
    enumType: 'downloadDataCalcu',
  },
  isByCountries: {
    label: 'By Countries',
    labelKey: 'dbi_label_separate_by_country_combine',
    value: 'market',
    key: 'isByCountries',
    enumType: 'downloadDataCalcu',
  },
  isSeperateByRegion: {
    label: 'Separate by Region',
    labelKey: 'dbi_label_separate_by_region',
    value: 'region',
    key: 'isSeperateByRegion',
    enumType: 'downloadDataCalcu',
  },
  isByRegion: {
    label: 'By Regions',
    labelKey: 'dbi_label_separate_by_region_combine',
    value: 'region',
    key: 'isByRegion',
    enumType: 'downloadDataCalcu',
  },
  isPlatformAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isPlatformAggregated',
    enumType: 'downloadDataCalcu',
  },
  isByPlatform: {
    label: 'By Platform',
    labelKey: 'dbi_label_separate_by_device_combine',
    value: 'separate',
    key: 'isByPlatform',
    enumType: 'downloadDataCalcu',
  },
  isSegmentAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isSegmentAggregated',
    enumType: 'downloadDataCalcu',
  },
  isBySegment: {
    label: 'By Platform',
    labelKey: 'dbi_label_separate_by_device_combine',
    value: 'separate',
    key: 'isBySegment',
    enumType: 'downloadDataCalcu',
  },
  isGenreAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isGenreAggregated',
    enumType: 'downloadDataCalcu',
  },
  isByGenre: {
    label: 'Separate by Genres',
    labelKey: 'dbi_label_separate_by_genres',
    value: 'parentGenre',
    key: 'isByGenre',
    enumType: 'downloadDataCalcu',
  },
  isBySubGenre: {
    label: 'Separate by Sub Genres',
    labelKey: 'dbi_label_separate_by_sub_genres',
    value: 'subGenre',
    key: 'isBySubGenre',
    enumType: 'downloadDataCalcu',
  },
  isGamesAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isGamesAggregated',
    enumType: 'downloadDataCalcu',
  },
  isByGames: {
    label: 'Separate by games',
    labelKey: 'dbi_label_separate_by_games',
    value: 'separate',
    key: 'isByGames',
    enumType: 'downloadDataCalcu',
  },
  isAnchorsAggregated: {
    ...DOWNLOAD_OPTIONS_COMMON.aggregated,
    value: 'aggregated',
    key: 'isAnchorsAggregated',
    enumType: 'downloadDataCalcu',
  },
  isShowTopInfluencers: {
    label: 'Show top influencers',
    labelKey: 'dbi_label_show_top_influencers',
    value: 'separate',
    key: 'isShowTopInfluencers',
    enumType: 'downloadDataCalcu',
  },
  isRegion: {
    label: 'Region',
    labelKey: 'dbi_global_view_region',
    value: 'region',
    key: 'isRegion',
    enumType: 'downloadDataCalcu',
  },
  isCoreMarkets: {
    label: 'Core Markets',
    labelKey: 'dbi_global_view_core_markets',
    value: 'market',
    key: 'isCoreMarkets',
    enumType: 'downloadDataCalcu',
  }
};

export const DOWNLOAD_OTHER_OPTIONS: IDownloadOtherOptions = {
  exportAllData: {
    label: 'Export all data',
    labelKey: 'dbi_export_all_data',
    value: 'all',
    key: 'exportAllData',
    enumType: 'downloadOther',
  },
  selectTop: {
    label: 'Select Top',
    labelKey: 'dbi_select_top',
    value: 'top',
    key: 'selectTop',
    enumType: 'downloadOther',
  },
  exportExcel: {
    label: 'Excel',
    value: 'excel',
    key: 'exportExcel',
    enumType: 'downloadOther',
  },
  exportCSV: {
    label: 'CSV',
    value: 'csv',
    key: 'exportCSV',
    enumType: 'downloadOther',
  },
  exportSelected: {
    ...DOWNLOAD_OPTIONS_COMMON.selected,
    value: 'selected',
    key: 'exportSelected',
    enumType: 'downloadOther',
  },
  exportSpecialSelected: {
    ...DOWNLOAD_OPTIONS_COMMON.selected,
    value: 'specialSelected',
    key: 'exportSpecialSelected',
    enumType: 'downloadOther',
  },
};

export const DOWNLOAD_MAIN_CATEGORY: IDownloadMainCategory = {
  source: {
    label: 'Source',
    labelKey: 'dbi_source',
    value: 'source',
    key: 'source',
    enumType: 'downloadMainCategory',
  },
  mobileSource: {
    label: 'Source',
    labelKey: 'dbi_source',
    value: 'mobileSource',
    key: 'mobileSource',
    enumType: 'downloadMainCategory',
  },
  dataSource: {
    label: 'Source',
    labelKey: 'dbi_source',
    value: 'dataSource',
    key: 'dataSource',
    enumType: 'downloadMainCategory',
  },
  streamSource: {
    label: 'Stream source',
    labelKey: 'dbi_benchmark_stream_source',
    value: 'streamSource',
    key: 'streamSource',
    enumType: 'downloadMainCategory',
  },
  timeScale: {
    label: 'Time scale',
    labelKey: 'dbi_benchmark_time_scale',
    value: 'timeScale',
    key: 'timeScale',
    enumType: 'downloadMainCategory',
  },
  metrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'metrics',
    key: 'metrics',
    enumType: 'downloadMainCategory',
  },
  mutilMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'mutilMetrics',
    key: 'mutilMetrics',
    enumType: 'downloadMainCategory',
  },
  singleMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'singleMetrics',
    key: 'singleMetrics',
    enumType: 'downloadMainCategory',
  },
  mobileMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'mobileMetrics',
    key: 'mobileMetrics',
    enumType: 'downloadMainCategory',
  },
  companiesMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'companiesMetrics',
    key: 'companiesMetrics',
    enumType: 'downloadMainCategory',
  },
  benchmarkMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'benchmarkMetrics',
    key: 'benchmarkMetrics',
    enumType: 'downloadMainCategory',
  },
  basicInformation: {
    label: 'Basic information',
    labelKey: 'dbi_label_basic_info',
    value: 'basicInformation',
    key: 'basicInformation',
    enumType: 'downloadMainCategory',
  },
  basicInformationOptional: {
    label: 'Basic information(optional)',
    labelKey: 'dbi_label_basic_info_optional',
    value: 'basicInformation',
    key: 'basicInformationOptional',
    enumType: 'downloadMainCategory',
  },
  dataCalculation: {
    label: 'Data Calculation',
    labelKey: 'dbi_label_data_calculation',
    value: 'dataCalculation',
    key: 'dataCalculation',
    enumType: 'downloadMainCategory',
  },
  benchmarkPlatformSettings: {
    label: 'Platform Settings',
    labelKey: 'dbi_label_platform_settings',
    value: 'benchmarkPlatformSettings',
    key: 'benchmarkPlatformSettings',
    enumType: 'downloadMainCategory',
  },
  regionSettings: {
    label: 'Region Settings',
    labelKey: 'dbi_label_region_settings',
    value: 'regionSettings',
    key: 'regionSettings',
    enumType: 'downloadMainCategory',
  },
  dataAmount: {
    label: 'Data Amount',
    labelKey: 'dbi_label_data_amount',
    value: 'dataAmount',
    key: 'dataAmount',
    enumType: 'downloadMainCategory',
  },
  selectTop: {
    label: '',
    labelKey: '',
    value: 'selectTop',
    key: 'selectTop',
    enumType: 'downloadMainCategory',
  },
  fileFormat: {
    label: 'File Format',
    labelKey: 'dbi_label_file_format',
    value: 'fileFormat',
    key: 'fileFormat',
    enumType: 'downloadMainCategory',
  },
  specialCountrySettring: {
    label: 'Country Settings',
    labelKey: 'dbi_label_country_settings',
    value: 'regionSettings',
    key: 'specialCountrySettring',
    enumType: 'downloadMainCategory',
  },
  otherSettings: {
    label: 'Other Settings',
    labelKey: 'dbi_label_other_settings',
    value: 'dataAmount',
    key: 'otherSettings',
    enumType: 'downloadMainCategory',
  },
  ratio: {
    label: 'Ratio',
    labelKey: 'dbi_label_ratio',
    value: 'ratio',
    key: 'ratio',
    enumType: 'downloadMainCategory',
  },
  dataSettings: {
    label: 'Data Settings',
    labelKey: 'dbi_label_data_settings',
    value: 'dataSettings',
    key: 'dataSettings',
    enumType: 'downloadMainCategory',
  },
  specialDataSettings: {
    label: 'Data Settings',
    labelKey: 'dbi_label_data_settings',
    value: 'specialDataSettings',
    key: 'specialDataSettings',
    enumType: 'downloadMainCategory',
  },
  timeSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'timeSettings',
    key: 'timeSettings',
    enumType: 'downloadMainCategory',
  },
  editionSettings: {
    label: 'Edition Settings',
    labelKey: 'dbi_label_edition_settings',
    value: 'editionSettings',
    key: 'editionSettings',
    enumType: 'downloadMainCategory',
  },
  specialEditionSettings: {
    label: 'Edition Settings',
    labelKey: 'dbi_label_edition_settings',
    value: 'specialEditionSettings',
    key: 'specialEditionSettings',
    enumType: 'downloadMainCategory',
  },
  dateSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'dateSettings',
    key: 'dateSettings',
    enumType: 'downloadMainCategory',
  },
  special_dateSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'special_dateSettings',
    key: 'special_dateSettings',
    enumType: 'downloadMainCategory',
  },
  mobileDateSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'mobileDateSettings',
    key: 'mobileDateSettings',
    enumType: 'downloadMainCategory',
  },
  timeSettingsDateType: {
    label: '',
    value: 'timeSettingsDateType',
    key: 'timeSettingsDateType',
    enumType: 'downloadMainCategory',
  },
  timeSettingsByTime: {
    label: '',
    value: 'timeSettingsByTime',
    key: 'timeSettingsByTime',
    enumType: 'downloadMainCategory',
  },
  special_dateSettingsByTime: {
    label: '',
    value: 'special_dateSettingsByTime',
    key: 'special_dateSettingsByTime',
    enumType: 'downloadMainCategory',
  },
  platformSettings: {
    label: 'Platform Settings',
    labelKey: 'dbi_label_platform_settings',
    value: 'platformSettings',
    key: 'platformSettings',
    enumType: 'downloadMainCategory',
  },
  special_platformSettings: {
    label: 'Platform Settings',
    labelKey: 'dbi_label_platform_settings',
    value: 'special_platformSettings',
    key: 'special_platformSettings',
    enumType: 'downloadMainCategory',
  },
  // TODO: 待调试
  platformSettingsNPD: {
    label: 'Platform Settings(NPD)',
    labelKey: 'dbi_label_npd_device_settings',
    value: 'platformSettingsNPD',
    key: 'platformSettingsNPD',
    enumType: 'downloadMainCategory',
  },
  platformSettingsGSD: {
    label: 'Platform Settings(GSD)',
    labelKey: 'dbi_label_gsd_device_settings',
    value: 'platformSettingsGSD',
    key: 'platformSettingsGSD',
    enumType: 'downloadMainCategory',
  },
  platformSettingsMscience: {
    label: 'Platform Settings(Mscience)',
    labelKey: 'dbi_label_mscience_device_settings',
    value: 'platformSettingsMscience',
    key: 'platformSettingsMscience',
    enumType: 'downloadMainCategory',
  },
  platformSettingsFamitsu: {
    label: 'Platform Settings(Famitsu)',
    labelKey: 'dbi_label_famitsu_device_settings',
    value: 'platformSettingsFamitsu',
    key: 'platformSettingsFamitsu',
    enumType: 'downloadMainCategory',
  },
  gamePlatform: {
    label: 'Game Platform',
    labelKey: 'dbi_game_platform',
    value: 'gamePlatform',
    key: 'gamePlatform',
    enumType: 'downloadMainCategory',
  },
  genreCategory: {
    label: 'Genre Category',
    labelKey: 'dbi_genre_category',
    value: 'genreCategory',
    key: 'genreCategory',
    enumType: 'downloadMainCategory',
  },
  dataCategory: {
    label: 'Data Category',
    labelKey: 'dbi_genre_profile_data_category',
    value: 'dataCategory',
    key: 'dataCategory',
    enumType: 'downloadMainCategory',
  },
  genre: {
    label: 'Genre',
    labelKey: 'dbi_label_genre',
    value: 'genre',
    key: 'genre',
    enumType: 'downloadMainCategory',
  },
  SpecialDataCategory: {
    label: 'Platform',
    labelKey: 'dbi_platform',
    value: 'dataCategory',
    key: 'platform',
    enumType: 'downloadMainCategory',
  },
  platform: {
    label: 'Platform',
    labelKey: 'dbi_platform',
    value: 'platform',
    key: 'platform',
    enumType: 'downloadMainCategory',
  },
  marketSettings: {
    label: 'Market Settings',
    labelKey: 'dbi_global_view_market_settings',
    value: 'marketSettings',
    key: 'marketSettings',
    enumType: 'downloadMainCategory',
  },
  genreSettings: {
    label: 'Genre Settings',
    labelKey: 'dbi_label_genre_settings',
    value: 'genreSettings',
    key: 'genreSettings',
    enumType: 'downloadMainCategory',
  },
  overlapMetrics: {
    label: 'Metrics',
    labelKey: 'dbi_label_metrics',
    value: 'overlapMetrics',
    key: 'overlapMetrics',
    enumType: 'downloadMainCategory',
  },
  overlapPlatformSettings: {
    label: 'Platform Settings',
    labelKey: 'dbi_label_platform_settings',
    value: 'overlapPlatformSettings',
    key: 'overlapPlatformSettings',
    enumType: 'downloadMainCategory',
  },
  timePickerSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'timePickerSettings',
    key: 'timePickerSettings',
    enumType: 'downloadMainCategory',
  },
  countrySettings: {
    label: 'Country Settings',
    labelKey: 'dbi_label_country_settings',
    value: 'countrySettings',
    key: 'countrySettings',
    enumType: 'downloadMainCategory',
  },
  dataCalculationChange: {
    label: 'Data Calculation Change',
    labelKey: 'dbi_label_data_calculation_change',
    value: 'dataCalculationChange',
    key: 'dataCalculationChange',
    enumType: 'downloadMainCategory',
  },
  special_datePickerSettings: {
    label: 'Time Settings',
    labelKey: 'dbi_label_time_settings',
    value: 'special_datePickerSettings',
    key: 'special_datePickerSettings',
    enumType: 'downloadMainCategory',
  },
  chart: {
    label: 'Chart',
    labelKey: 'dbi_label_chart',
    value: 'chart',
    key: 'chart',
    enumType: 'downloadMainCategory',
  },
  special_dataCalculationChange: {
    label: 'Data Calculation Change',
    labelKey: 'dbi_label_data_calculation_change',
    value: 'special_dataCalculationChange',
    key: 'special_dataCalculationChange',
    enumType: 'downloadMainCategory',
  },
  anchorsSettings: {
    label: 'Anchors Settings',
    labelKey: 'dbi_label_anchors_settings',
    value: 'anchorsSettings',
    key: 'anchorsSettings',
    enumType: 'downloadMainCategory',
  },
  gameSettings: {
    label: 'Game Settings',
    labelKey: 'dbi_label_game_settings',
    value: 'gameSettings',
    key: 'gameSettings',
    enumType: 'downloadMainCategory',
  }
};
